import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Button } from "react-bootstrap";
import Select from 'react-select';
import { buildUrl } from '../helper/handler';
import { getFromApi } from '../utilities/NetUtilities';
import { Settimane } from '../helper/settimaneTurniLavoro';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function FiltriPerLavoratore(props) {
  const [lavoratore, setLavoratore] = useState(null);
  const [settimana, setSettimana] = useState(null);
  const [settimanaCorrente, setSettimanaCorrente] = useState(null);
  const [settimaneConTurni, setSettimaneConTurni] = useState({});
  const { setMessage } = props;
  const settimanaRef = useRef(settimana);
  
  useEffect(() => {
    settimanaRef.current = settimana;
  }, [settimana]);

  useEffect(() => {
    const setMessageFromApi = (data) => {
      setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
    }
    getFromApi(buildUrl('settimanaCorrenteTurniLavoro'), handleSettimana, setMessageFromApi);
  }, [setMessage]);

  // Reset quando cambia lavoratore
  useEffect(() => {
    if (lavoratore) {
      props.setSettimaneOptions(Settimane);
      if (settimanaRef.current) {
        const baseSettimana = Settimane.find(s => s.value === settimanaRef.current.value);
        if (baseSettimana) {
          setSettimana(baseSettimana);
        }
      }
    } else {
      props.setSettimaneOptions(Settimane);
      setSettimaneConTurni({});
    }
  }, [lavoratore]);

  // Carica settimane con turni
  useEffect(() => {
    const setMessageFromApi = (data) => {
      setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
    }
    const fetchSettimaneConTurni = (lavoratoreId) => {
      const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
      if (organizzazioneMap) {
        const url = buildUrl('settimaneConTurniPerLavoratore', {
          lavoratore: lavoratoreId,
          organizzazione: organizzazioneMap.nome,
          tipo: organizzazioneMap.tipo
        });

        getFromApi(url, handleSettimaneConTurni, setMessageFromApi);
      }
    };
    if (lavoratore) {
      fetchSettimaneConTurni(lavoratore.value);
    }
  }, [lavoratore, props.refreshSettimaneConTurni, setMessage]);

  useEffect(() => {
    if (Object.keys(settimaneConTurni).length > 0) {
      const updatedSettimaneOptions = Settimane.map(settimana => {
        const settimanaInfo = settimaneConTurni[settimana.label];
        if (settimanaInfo && settimanaInfo.hasTurni) {
          return {
            ...settimana,
            label: `${settimana.label} (totale ore: ${settimanaInfo.oreTotali})`,
            oreTotali: settimanaInfo.oreTotali
          };
        }
        return settimana;
      });
      props.setSettimaneOptions(updatedSettimaneOptions);
      if (settimanaRef.current) {
        const currentSettimanaIndex = updatedSettimaneOptions.findIndex(s => s.value === settimanaRef.current.value);
        if (currentSettimanaIndex !== -1) {
          setSettimana(updatedSettimaneOptions[currentSettimanaIndex]);
        }
      }
    } else if (Object.keys(settimaneConTurni).length === 0 && settimanaRef.current) {
      // Reset alla settimana base quando non ci sono turni
      const baseSettimana = Settimane.find(s => s.value === settimanaRef.current.value);
      if (baseSettimana) {
        setSettimana(baseSettimana);
      }
    }
  }, [settimaneConTurni]);

  const handleSettimaneConTurni = (data) => {
    if (data && data.settimane) {
      const settimaneInfo = {};

      data.settimane.forEach(item => {
        settimaneInfo[item.settimana] = {
          hasTurni: true,
          oreTotali: item.oreTotali || "0:00"
        };
      });
      setSettimaneConTurni(settimaneInfo);
    }
  };

  const handleSettimana = (data) => {
    const settimanaAttuale = Settimane.find(s => s.value === data.value);
    if (settimanaAttuale) {
      setSettimanaCorrente(settimanaAttuale);
      setSettimana(settimanaAttuale);
    }
  };

  const notificaFiltroChanged = (newLavoratore, newSettimana) => {
    if (newLavoratore && newSettimana) {
      props.filtroChanged(newLavoratore, typeof newSettimana === 'object' ? newSettimana.value : newSettimana);
    }
  };

  const lavoratoreChanged = (newLavoratore) => {
    setLavoratore(newLavoratore);
    if (settimana) {
      notificaFiltroChanged(newLavoratore, settimana);
    }
  };

  const settimanaChanged = (newSettimana) => {
    setSettimana(newSettimana);
    if (lavoratore) {
      notificaFiltroChanged(lavoratore, newSettimana);
    }
  };

  const handlePrevSettimana = () => {
    if (!settimana) return;

    const currentIndex = props.settimaneOptions.findIndex(s => s.value === settimana.value);
    if (currentIndex > 0) {
      const prevSettimana = props.settimaneOptions[currentIndex - 1];
      setSettimana(prevSettimana);
      if (lavoratore) {
        notificaFiltroChanged(lavoratore, prevSettimana);
      }
    }
  };

  const handleNextSettimana = () => {
    if (!settimana) return;

    const currentIndex = props.settimaneOptions.findIndex(s => s.value === settimana.value);
    if (currentIndex < props.settimaneOptions.length - 1) {
      const nextSettimana = props.settimaneOptions[currentIndex + 1];
      setSettimana(nextSettimana);
      if (lavoratore) {
        notificaFiltroChanged(lavoratore, nextSettimana);
      }
    }
  };

  const handleTodaySettimana = () => {
    if (!settimanaCorrente) return;
    const settimanaAggiornata = props.settimaneOptions.find(s => s.value === settimanaCorrente.value) || settimanaCorrente;
    setSettimana(settimanaAggiornata);
    if (lavoratore) {
      notificaFiltroChanged(lavoratore, settimanaAggiornata);
    }
  };

  const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.data.value === (settimanaCorrente?.value || '') || state.isSelected
      ? '#e6f2ff'
      : state.data.oreTotali && state.data.oreTotali !== "0:00"
        ? '#f7d3d4'
        : provided.backgroundColor,
    fontWeight: state.data.value === (settimanaCorrente?.value || '') ||
      (state.data.oreTotali && state.data.oreTotali !== "0:00") ||
      state.isSelected
      ? 'bold'
      : 'normal',
    color: state.data.value === (settimanaCorrente?.value || '') ||
      (state.data.oreTotali && state.data.oreTotali !== "0:00") ||
      state.isSelected
      ? '#000000'
      : provided.color
  }),
};

  return (
    <Row className='row d-flex justify-content-center'>
      <Col xl={3} sm={4} xs={12} id="lavoratore-filtro">
        <p className="inEvidenza">lavoratore</p>
        <Select
          id="lavoratore-filtro-select"
          name="lavoratore"
          instanceId="lavoratore"
          options={props.lavoratori}
          onChange={lavoratoreChanged}
          placeholder="Seleziona..."
          value={lavoratore}
        />
      </Col>
      <Col xl={5} sm={4} xs={12} id="settimana-filtro">
        <p className="inEvidenza">settimana</p>
        <Select
          id="settimana-filtro-select"
          name="settimanainizio"
          instanceId="settimana"
          options={props.settimaneOptions}
          onChange={settimanaChanged}
          placeholder="Seleziona..."
          value={settimana}
          styles={customStyles}
        />
      </Col>
      <Col xl={3} sm={4} xs={12} id="settimana-navigazione" className="d-flex align-items-end">
        <Button
          id="precedente"
          variant="primary"
          size="sm"
          title="indietro"
          onClick={handlePrevSettimana}
          disabled={!settimana || Settimane.findIndex(s => s.value === settimana?.value) === 0}
        >
          <FaChevronLeft></FaChevronLeft>
        </Button>
        <Button
          id="oggi"
          variant="outline-primary"
          size="sm" style={{
            fontWeight: 'bold'
          }}
          onClick={handleTodaySettimana}
          disabled={!settimanaCorrente || (settimana && settimana.value === settimanaCorrente.value)}
        >
          Oggi
        </Button>
        <Button
          id="successiva"
          variant="primary"
          size="sm"
          title="avanti"
          onClick={handleNextSettimana}
          disabled={!settimana || Settimane.findIndex(s => s.value === settimana?.value) === Settimane.length - 1}
        >
          <FaChevronRight></FaChevronRight>
        </Button>
      </Col>
    </Row>
  );
}

export default FiltriPerLavoratore;